import { fetchMilestonesToBeBilled } from '@/services';
import { MilestonesToBeBilledQueryParams } from '@/services/billing/billing.service';
import { useQuery } from '@tanstack/react-query';
import { groupMilestonesByMonth } from '../utils/billing.utils';

export const useMilestonesToBeBilled = (filters: MilestonesToBeBilledQueryParams) => {
  const { data: milestonesToBeBilled } = useQuery({
    queryKey: ['milestones-to-be-billed', filters],
    queryFn: () => fetchMilestonesToBeBilled(filters),
    enabled: !!filters.organizationId,
  });

  const groupedMilestones = groupMilestonesByMonth(milestonesToBeBilled ?? []);

  return { milestonesToBeBilled, groupedMilestones };
};
